import { usePaginatedQuery, useQueryCache } from 'react-query'
import usersFetchService from '../../services/api/users-fetch'
import useCurrentUser from '../use-current-user'
import { get } from 'lodash'
import useUsersFilters from '../use-users-filters'
import { useCallback } from 'react'
import useCacheKeys from '../use-cache-keys'

const useUsers = ({
    filters = {},
    enabled = true,
    onReload = () => {},
} = {}) => {
    //  We don't want to do queries unless current user is loaded
    const { currentUser } = useCurrentUser()
    const cacheKeys = useCacheKeys()

    //  Use the context filters if possible
    const { filters: contextFilters } = useUsersFilters()

    //  Create memoized callback
    const fetchUsers = useCallback((key, filters) => {
        return usersFetchService(filters)
    }, [])

    //  Configure the paginated query
    const { isLoading, resolvedData } = usePaginatedQuery([cacheKeys.USERS, { ...contextFilters, ...filters }], fetchUsers, { enabled: Boolean(currentUser) && enabled})

    const cache = useQueryCache()

    const reloadUsers = useCallback(() => {
        cache.invalidateQueries(cacheKeys.USERS,)
        onReload()
    }, [cache, onReload])

    //  Work with resolved data (if there is resolved data?)
    const total = get(resolvedData, 'total', 0)
    const users = get(resolvedData, 'items', [])

    return {
        isLoading,
        users,
        total,
        reloadUsers
    }
}

export default useUsers